import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from './Navbar';
import FAB from './FAB';
import CreatePostModal from './CreatePostModal';
import { AppContext } from '../context/AppContext';

export default function Layout({ children }) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { addPost, token } = useContext(AppContext);
  const navigate = useNavigate();

  const handlePostSubmit = async (data) => {
    const { text, category, ...extraData } = data;
    await addPost(text, category, extraData);
  };

  const handleFabClick = () => {
    if (!token) {
       navigate('/login');
    } else {
       setIsModalOpen(true);
    }
  };

  return (
    <div className="min-h-screen flex flex-col bg-white dark:bg-selffo-dark text-slate-900 dark:text-slate-100 transition-colors">
      <Navbar />
      
      <main className="flex-1 max-w-2xl w-full mx-auto sm:border-x border-slate-100 dark:border-slate-900/50 pt-16 pb-36 sm:pb-0 min-h-screen">
        {children}
      </main>

      <div id="create-post-btn" onClick={handleFabClick} className="hidden" />
      <FAB onClick={handleFabClick} />

      {isModalOpen && (
        <CreatePostModal 
          isOpen={isModalOpen} 
          onClose={() => setIsModalOpen(false)} 
          onSubmit={handlePostSubmit} 
        />
      )}
    </div>
  );
}
